import axios, {AxiosResponse} from 'axios';
import {
    CodesRetrievePaginatedResponse,
    CodesRetrieveResponse,
    ColumnRetrieveResponse,
    FileUploadResponse,
    IdfRetrieveResponse,
    RowCountRetrieveResponse,
    WhoddRetrieveResponse
} from '@/model/CommonModel';

export default class CommonApi {
    public static retrieveCodes(codeId: string): Promise<CodesRetrieveResponse> {
        if (codeId === 'DAY_TYPE') {
            const response: CodesRetrieveResponse = {
                data: {
                    codeId: '',
                    codeList: [
                        {
                            codeValue: 'CALENDAR',
                            codeLabel: 'CALENDAR'
                        }
                    ]
                },
                success: true
            };
            return Promise.resolve(response);
        }

        return axios.get(`/1.0/codes/${codeId}`)
                    .then((res: AxiosResponse) => res.data);
    }

    public static retrieveWhoddCountries(version: string): Promise<CodesRetrieveResponse> {
        return axios
            .get(`/1.0/codes/${version}/WHODD_COUNTRY`)
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveWhoddCodes(params: any = {}): Promise<WhoddRetrieveResponse> {
        return axios
            .get('/1.0/codes/WHODD_CODE', {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static retrievePaginatedCodes(codeId: string, params: any = {}): Promise<CodesRetrievePaginatedResponse> {
        return axios.get(`/1.1/codes/${codeId}?chunk`, {params})
                    .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveColumns(menuId: string): Promise<ColumnRetrieveResponse> {
        return axios
            .get(`/1.0/menus/${menuId}/columns`)
            .then((res: AxiosResponse) => res.data);
    }

    public static uploadFile(sponsorKey: string, file: File): Promise<FileUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);

        return axios
            .post(`/1.0/sponsors/${sponsorKey}/files`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((res: AxiosResponse) => res.data);
    }

    public static getCommonFilterInfo(menuId: string): Promise<RowCountRetrieveResponse> {
        return axios
            .get(`/1.1/menus/${menuId}/common-list-info`)
            .then((res: AxiosResponse) => res.data);
    }

    public static saveCommonFilterInfo(menuId: string, rowCount: number, fullText: string): Promise<any> {
        return axios
            .put(`/1.1/menus/${menuId}/row-count/${rowCount}/full-text/${fullText}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static saveFullTextFilter(menuId: string, fullText: string): Promise<any> {
        return axios
          .put(`/1.1/menus/${menuId}/full-text/${fullText}`)
          .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveIdfCodes(params: any = {}): Promise<IdfRetrieveResponse> {
        return axios
            .get('/1.0/codes/IDF_CODE', {params})
            .then((res: AxiosResponse) => res.data);
    }
}
